import {Component, HostListener} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {UiCardComponent} from "../../../ui-utils/components/ui-card/ui-card.component";
import {Route, Router} from "@angular/router";
import {NgClass} from "@angular/common";
import {Panel} from "primeng/panel";
import {PrimeTemplate} from "primeng/api";

@Component({
  selector: 'app-navigation',
  standalone: true,
  imports: [
    ButtonDirective,
    UiCardComponent,
    NgClass,
    Panel,
    PrimeTemplate
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.less'
})

@HostListener('window:resize')

export class NavigationComponent {
  isMobile = window.innerWidth <= 768;
  collapsed = this.isMobile
  currentRoute: string;


  constructor(private router: Router) {
    this.currentRoute = this.router.url;
  }

  onResize(): void {
    const mobile = window.innerWidth <= 768;

    if (mobile !== this.isMobile) {
      this.isMobile = mobile;

      if (!mobile) {
        this.collapsed = false;
      }
    }
  }

  goTo(route: string): void {
    this.router.navigate([route]);
  }

  isActive(route: string): boolean {
    return this.currentRoute === route;
  }
}
